import { render, staticRenderFns } from "./StudentInfoes.vue?vue&type=template&id=69bc10d0&scoped=true&"
import script from "./StudentInfoes.vue?vue&type=script&lang=js&"
export * from "./StudentInfoes.vue?vue&type=script&lang=js&"
import style0 from "./StudentInfoes.vue?vue&type=style&index=0&id=69bc10d0&lang=scss&scoped=true&"
import style1 from "./StudentInfoes.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bc10d0",
  null
  
)

export default component.exports